import React, { FunctionComponent, MutableRefObject } from 'react';
import { UseFormRegister, UseFormTrigger } from 'react-hook-form';

import Input from '../../../atoms/Form/Input';
import { InputProps } from '../../../atoms/Form/Input/Input.types';

function mergeRefs(
  refs: Array<
    | MutableRefObject<HTMLInputElement | null>
    | ((instance: HTMLInputElement | null) => void)
    | null
  >,
): React.RefCallback<HTMLInputElement | null> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref !== null) {
        ref.current = value;
      }
    });
  };
}

interface InputHookFormProps extends Exclude<InputProps, 'onChange'> {
  register: UseFormRegister<any>;
  trigger?: UseFormTrigger<any>;
  name: string;
  internalId?: string;
  suffixOptionButton?: React.ComponentType<any>;
}
interface InputHookFormPWithRef extends InputHookFormProps {
  forwardedRef:
    | MutableRefObject<HTMLInputElement | null>
    | ((instance: HTMLInputElement | null) => void)
    | null;
}

const InputHookForm: FunctionComponent<
  React.PropsWithChildren<InputHookFormPWithRef>
> = ({
  register,
  name,
  validatingRegex,
  trigger,
  forwardedRef,
  internalId,
  suffixOptionButton,
  ...rest
}) => {
  const { ref, onChange, ...resgisteredInput } = register(name);

  return (
    <Input
      {...rest}
      {...resgisteredInput}
      onChange={(event) => {
        if (validatingRegex && event.target.value && trigger) {
          trigger(name);
        }

        return onChange(event);
      }}
      ref={mergeRefs([ref, forwardedRef])}
      internalId={internalId}
      suffixOptionButton={suffixOptionButton}
    />
  );
};

export default React.forwardRef<HTMLInputElement, InputHookFormProps>(
  (props, ref) => <InputHookForm forwardedRef={ref} {...props} />,
);
